<template>
  <el-button
    type="primary"
    size="mini"
    :loading="loading"
    :disabled="order.paid || order.status === 'E'"
    @click="onClick"
  >
    Confirm Availability
  </el-button>
</template>

<script>
export default {
  props: {
    order: Object,
  },

  data() {
    return {
      loading: false,
    }
  },

  methods: {
    async onClick() {
      try {
        await this.$confirm('I hereby confirm that all products are available in the ordered quantity and ready to be shipped. The customer’s payment method will be charged.', 'Confirm Order', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
      } catch(err) {
        return false
      }

      this.loading = true

      try {
        var { data } = await this.$http.post(`/orders/${ this.order.id }/charge`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        this.$emit('error')
        return false
      } finally {
        this.loading = false
      }

      this.$emit('success')
      this.$message.success('Order has been confirmed.')
    },
  },
}
</script>
